export const EDITOR_ARTICLE = "EditArticle";
export const EDITOR_ACCOUNT = "AccountEditor";
export const EDITOR_SUPPLIER = "SupplierEditor";
export const EDITOR_TAXBASE = "TaxBase";
export const SEE_DOCUMENT = "SeeDocument";
export const RUB_PRESUPUESTAL ="BudgetIDSelector";
export const RUB_VALUE ="BudgetValueEditor";
export const VALUE_APROP ="ValorApropieacion"
export const RESOURCE_APROP ="RecursoPresupuestal"